import { MinzeElement } from 'minze'

export class LvcClearFilterButton extends MinzeElement {
  html = () => `
    <button class="clear-filter-button">
      <lvc-close-icon></lvc-close-icon>
    </button>
  `

  css = () => `
    .clear-filter-button {
      position: absolute;
      right: 10px;
      bottom: 0;
      top: 0;
      background: transparent;
      border: none;
      cursor: pointer;
    }
  `
}
